module.exports = __webpack_public_path__ + "static/media/zeroe_perfect.19a7a112.jpeg";